import { PASSPORT_FILE_OPEN, PASSPORT_REQUEST, PASSPORT_REQUEST_ERROR, PASSPORT_REQUEST_SUCCESS, SELECTED_HEALTH_REC_ID, SELECTED_HEALTH_REC_ID_ERROR, SELECTED_HEALTH_REC_ID_SUCCESS, SELECTED_PRESCRIPTION_ID, SELECTED_PRESCRIPTION_ID_ERROR, SELECTED_PRESCRIPTION_ID_SUCCESS } from './Constants';

export const passportRequest = () => ({
    type: PASSPORT_REQUEST
});

export const passportRequestSuccess = (data) => ({
    type: PASSPORT_REQUEST_SUCCESS,
    data : data
});

export const passportRequestError = () => ({
    type: PASSPORT_REQUEST_ERROR
});

export const selectedPrescriptionIdRequest = (id) => ({
    type: SELECTED_PRESCRIPTION_ID,
    prescriptionId : id
});

export const selectedPrescriptionIdRequestSuccess = (data) => ({
    type: SELECTED_PRESCRIPTION_ID_SUCCESS,
    prescriptionData : data
});

export const selectedPrescriptionIdRequestError = () => ({
    type: SELECTED_PRESCRIPTION_ID_ERROR,
});

export const passportFileOpenRequest = (url) => ({
    type: PASSPORT_FILE_OPEN,
    url : url
});

export const selectedHealthRecIdRequest = (id) => ({
    type: SELECTED_HEALTH_REC_ID,
    healthRecId : id
});

export const selectedHealthRecIdRequestSuccess = (data) => ({
    type: SELECTED_HEALTH_REC_ID_SUCCESS,
    healthRecData : data
});

export const selectedHealthRecIdRequestError = () => ({
    type: SELECTED_HEALTH_REC_ID_ERROR,
});